import type { TourDefinition } from '../types';
import { TOUR_IDS } from '../types';

export const tournamentStructureTour: TourDefinition = {
  id: TOUR_IDS.TOURNAMENT_STRUCTURE,
  steps: [
    {
      target: '[data-tour="structure-header"]',
      titleKey: 'tournamentStructure.welcome.title',
      contentKey: 'tournamentStructure.welcome.content',
      placement: 'center',
      skipBeacon: true,
    },
    {
      target: '[data-tour="structure-seeding"]',
      titleKey: 'tournamentStructure.seeding.title',
      contentKey: 'tournamentStructure.seeding.content',
      placement: 'bottom-start',
      disableFlip: true,
    },
    {
      target: '[data-tour="structure-add"]',
      titleKey: 'tournamentStructure.addStructure.title',
      contentKey: 'tournamentStructure.addStructure.content',
      placement: 'bottom-end',
      disableFlip: true,
    },
    {
      target: '[data-tour="structure-stages-anchor"]',
      spotlightTarget: '[data-tour="structure-stages"]',
      titleKey: 'tournamentStructure.stages.title',
      contentKey: 'tournamentStructure.stages.content',
      // Centered above the Qualifier / stage card (not overlapping it).
      placement: 'top',
      disableFlip: true,
      offset: 12,
      topScrollRoom: 280,
      floatingOptions: {
        shiftOptions: {
          padding: { top: 8, bottom: 24, left: 16, right: 16 },
          mainAxis: false,
          crossAxis: true,
          rootBoundary: 'viewport',
        },
      },
    },
  ],
};
